<template>
  <Field v-slot="{ componentField }" :name="name" :rules="rules">
    <FormItem :no-errors="noErrors">
      <!-- @vue-ignore radix / vee-validate 与本地表单子组件的模板类型在 vue-tsc 下误报 -->
      <FormLabel>
        <slot name="label"> {{ label }} </slot>
      </FormLabel>
      <FormControl v-bind="veeFieldProps(componentField)">
        <slot></slot>
      </FormControl>
      <!-- @vue-ignore -->
      <FormDescription v-if="$slots.description || description">
        <slot name="description">{{ description }}</slot>
      </FormDescription>
      <!-- @vue-ignore -->
      <FormMessage />
    </FormItem>
  </Field>
</template>

<script setup lang="ts">
import { toTypedSchema } from '@vee-validate/zod';
import { Field } from 'vee-validate';
import { z, type ZodTypeAny } from 'zod';
import { useFormStore } from '../model/FormStore';
import type { IFormFieldProps } from '../types/FormField';
import FormControl from './FormControl.vue';
import FormDescription from './FormDescription.vue';
import FormItem from './FormItem.vue';
import FormLabel from './FormLabel.vue';
import FormMessage from './FormMessage.vue';
const formStore = useFormStore();
const props = defineProps<IFormFieldProps>();

/** vee-validate 的 componentField 与 FormControl 在 vue-tsc 严格模板下推断冲突，此处仅用于绑定透传 */
function veeFieldProps(field: unknown): any {
  return field;
}

function baseSchemaForFieldType(type: string | undefined): ZodTypeAny {
  switch (type) {
    case 'number':
      return z.number();
    case 'boolean':
      return z.boolean();
    case 'date':
      return z.date();
    default:
      return z.string();
  }
}

const rulesTransform = (rawRules: IFormFieldProps['rules']) => {
  if (!rawRules) return;
  if (typeof rawRules === 'string') return rawRules;
  const operator = Array.isArray(rawRules) ? rawRules : [rawRules];
  const initialSchema = baseSchemaForFieldType(props.type);

  const validator = operator.reduce((acc, ruleConf) => {
    const { message, ...other } = ruleConf;
    return Object.entries(other).reduce(
      (buf: ZodTypeAny, [k, v]) =>
        (buf as unknown as Record<string, (a: unknown, m?: string) => ZodTypeAny>)[k](v, message),
      acc,
    );
  }, initialSchema);
  return toTypedSchema(validator);
};
const rules = rulesTransform(props.rules);
</script>

<style scoped></style>
